/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';
import '../styles/JobDetailsSkeleton.css';

const JobDetailsSkeleton = () => {
  return (
    <div className="job-details-skeleton">
      {/* Header Skeleton */}
      <div className="skeleton-header shimmer">
        <div className="skeleton-header-content">
          <div className="skeleton-spacer"></div>
          <div className="skeleton-header-text">
            <div className="skeleton-title shimmer"></div>
            <div className="skeleton-company shimmer"></div>
          </div>
          <div className="skeleton-branding shimmer"></div>
        </div>
      </div>

      <div className="skeleton-content-wrapper">
        {/* Main Content */}
        <div className="skeleton-main-content">
          {/* Meta Grid Skeleton */}
          <div className="skeleton-meta-grid">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="skeleton-meta-item shimmer">
                <div className="skeleton-meta-icon"></div>
                <div className="skeleton-meta-text">
                  <div className="skeleton-meta-label"></div>
                  <div className="skeleton-meta-value"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Job Sections Skeleton */}
          {[1, 2, 3, 4].map((section) => (
            <div key={section} className="skeleton-section shimmer">
              <div className="skeleton-section-header">
                <div className="skeleton-section-icon"></div>
                <div className="skeleton-section-title"></div>
              </div>
              <div className="skeleton-section-content">
                <div className="skeleton-line"></div>
                <div className="skeleton-line"></div>
                <div className="skeleton-line short"></div>
              </div>
            </div>
          ))}

          {/* Skills Skeleton */}
          <div className="skeleton-section shimmer">
            <div className="skeleton-section-header">
              <div className="skeleton-section-icon"></div>
              <div className="skeleton-section-title"></div>
            </div>
            <div className="skeleton-skills-grid">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="skeleton-skill-tag"></div>
              ))}
            </div>
          </div>
        </div>

        {/* Sidebar Skeleton */}
        <div className="skeleton-sidebar">
          {/* Application Card Skeleton */}
          <div className="skeleton-card shimmer">
            <div className="skeleton-card-header">
              <div className="skeleton-card-title"></div>
            </div>
            <div className="skeleton-card-content">
              <div className="skeleton-line"></div>
              <div className="skeleton-line short"></div>
            </div>
            <div className="skeleton-button-large"></div>
          </div>

          {/* Stats Card Skeleton */}
          <div className="skeleton-card shimmer">
            <div className="skeleton-card-title"></div>
            <div className="skeleton-stats-grid">
              {[1, 2, 3].map((i) => (
                <div key={i} className="skeleton-stat-item">
                  <div className="skeleton-stat-icon"></div>
                  <div className="skeleton-stat-text">
                    <div className="skeleton-stat-value"></div>
                    <div className="skeleton-stat-label"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Actions Card Skeleton */}
          <div className="skeleton-card shimmer">
            <div className="skeleton-card-title"></div>
            <div className="skeleton-actions-list">
              {[1, 2, 3].map((i) => (
                <div key={i} className="skeleton-action-button"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsSkeleton;

